<svg:g>
    @for (bar of bars; track $index; let i = $index) {
    <svg:g ngx-charts-bar
           [width]="bar.width"
           [height]="bar.height"
           [x]="bar.x"
           [y]="bar.y"
           [fill]="bar.color"
           [stops]="bar.gradientStops"
           [data]="bar.data"
           [orientation]="barOrientation.Vertical"
           [roundEdges]="bar.roundEdges"
           [gradient]="gradient"
           [ariaLabel]="bar.ariaLabel"
           [isActive]="isActive(bar.data)"
           (select)="select.emit($event)"
           (activate)="activate.emit($event)"
           (deactivate)="deactivate.emit($event)"
           ngx-tooltip
           [tooltipDisabled]="tooltipDisabled"
           [tooltipPlacement]="tooltipPlacement"
           [tooltipType]="tooltipType"
           [tooltipTitle]="tooltipTemplate ? undefined : bar.tooltipText"
           [tooltipTemplate]="tooltipTemplate"
           [tooltipContext]="bar.data"
           [noBarWhenZero]="noBarWhenZero"
           [animations]="animations"></svg:g>
    }
</svg:g>